import _ from 'lodash'
import applicationDescriptionApi from '@/api/application-description'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    type: '',
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    applicationDescriptionApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  delete({ commit }, id) {
    return applicationDescriptionApi.delete(id)
      .then(() => commit('APPLICATION_DESCRIPTION_REMOVED', id))
      .catch((error) => {
        commit('APPLICATION_DESCRIPTION_REMOVE_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
  activate({ commit }, id) {
    return applicationDescriptionApi.activate(id)
      .then(() => commit('APPLICATION_DESCRIPTION_ACTIVATED', id))
      .catch((error) => {
        commit('APPLICATION_DESCRIPTION_ACTIVATION_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
  deactivate({ commit }, id) {
    return applicationDescriptionApi.deactivate(id)
      .then(() => commit('APPLICATION_DESCRIPTION_DEACTIVATED', id))
      .catch((error) => {
        commit('APPLICATION_DESCRIPTION_DEACTIVATION_FAILED', { id, errors: error.response.data.errors })
        throw error
      })
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  APPLICATION_DESCRIPTION_REMOVED(state, id) {
    store.dispatch('applicationDescription/fetchList')
    store.dispatch('message/success', 'APPLICATION_DESCRIPTION.success')
  },
  APPLICATION_DESCRIPTION_REMOVE_FAILED(state, { id, errors }) {
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.removeFailure')
    state.errors = errors
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  APPLICATION_DESCRIPTION_ACTIVATED(){
    store.dispatch('applicationDescription/fetchList')
  },
  APPLICATION_DESCRIPTION_ACTIVATION_FAILED(){
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.removeFailure')
    state.errors = errors
  },
  APPLICATION_DESCRIPTION_DEACTIVATED(){
    store.dispatch('applicationDescription/fetchList')
  },
  APPLICATION_DESCRIPTION_DEACTIVATION_FAILED(){
    store.dispatch('message/error', 'APPLICATION_DESCRIPTION.removeFailure')
    state.errors = errors
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.applicationDescription.filters, _.debounce(async () => await store.dispatch('applicationDescription/fetchList'), 250), {
    immediate: false,
    deep: true,
  }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
